module.exports = __webpack_public_path__ + "img/bg-wallet-failed-modal.76008c43.png";